<template>
	<v-card dense>
		<v-card-text class="pa-0">
			<apexchart
				width="100%"
				height="180"
				type="area"
				:options="chartOptions"
				:series="series"
			></apexchart>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: "AreaExample",
	data: function () {
		return {
			chartOptions: {
				title: {
					text: "100,000",
					offsetX: 10,
					offsetY: 30,
					style: {
						fontSize: "1.5rem",
						fontWeight: "bold",
						fontFamily: "Roboto, Helvetica, Arial, sans-serif",
						color: "#263238",
					},
				},
				subtitle: {
					text: "Reservations",
					offsetX: 10,
					offsetY: 40,
				},
				legend: {
					show: false,
				},
				sparkline: {
					enabled: true,
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: "smooth",
				},
				xaxis: {
					categories: [
						"Jan",
						"Feb",
						"Mar",
						"Apr",
						"May",
						"Jun",
						"Jul",
					],
					labels: {
						show: false,
					},
				},
				yaxis: {
					labels: {
						show: false,
					},
				},
				grid: {
					show: false,
				},
				chart: {
					toolbar: {
						show: false,
						tools: {
							download: false,
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
						},
					},
				},
			},
			series: [
				{
					name: "series1",
					data: [31, 40, 28, 51, 42, 109, 100],
				},
			],
		};
	},
};
</script>